import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Hero from "@/components/home/Hero";
import CategoryBar from "@/components/search/CategoryBar";
import DestinationsGrid from "@/components/home/DestinationsGrid";
import CuratedCollections from "@/components/home/CuratedCollections";
import FeaturedVillas from "@/components/home/FeaturedVillas";
import TestimonialCarousel from "@/components/home/TestimonialCarousel";
import WhyNirvagoo from "@/components/home/WhyNirvagoo";
import InspirationSection from "@/components/home/InspirationSection";
import CtaBand from "@/components/home/CtaBand";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const el = document.getElementById(hash.slice(1));
    if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 50);
  }, [hash]);

  return (
    <Box data-testid="home-page">
      <Hero />
      <CategoryBar />
      <DestinationsGrid />
      <CuratedCollections />
      <FeaturedVillas />
      <TestimonialCarousel />
      <WhyNirvagoo />
      <InspirationSection />
      <CtaBand />
    </Box>
  );
}
